<script setup>
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useLanguage } from './composables/useLanguage';
import { watch } from 'vue';
const route = useRoute();
const { locale } = useI18n();
watch(
  () => route.query.language,
  newLanguage => {
    if (newLanguage) {
      console.log(newLanguage); // Log the language when it changes
      useLanguage(locale, newLanguage);
    }
  },
  { immediate: true } // Ensures it triggers immediately on mounted
);
</script>

<template>
  <div class="app-container">
    <router-view class="main"></router-view>
  </div>
</template>
<style>
.ant-layout-sider {
  background: none;
}
.app-container {
  display: flex;
  height: 100vh;
}
</style>
